import {
  BaSeButton,
  BaSeDialogContext,
  BaSeFilePicker,
  BaSeIcon,
  BaSeParagraph,
  BaSeTheme,
} from '@base/react';

import * as React from 'react';
import {
  WrapperDownloadFile,
} from './importar-certificados-styled';

const FileImportCertificate = 'https://storage.googleapis.com/chatbot-ead/ead/arquivos_uteis/MODELO_IMPORTAR_CERTIFICADO.xlsx'

export const ImportarCertificados = ({
  setIsImportFiles,
  setFiles,
  setIsReport,
  sendFiles,
}) => {
  const [sizeFiles, setSizeFiles] = React.useState(0);
  const { azulSebrae36, cinzaSebrae45 } = BaSeTheme.colors.institucionais;
  const { showNotification } = React.useContext(BaSeDialogContext);

  return (
    <>
      <div
        style={{
          marginBottom: 50,
        }}
      >
        <WrapperDownloadFile>
          <BaSeIcon
            color={azulSebrae36}
            description="icon-download"
            name="file-download"
            size={17}
          />
          <BaSeParagraph
            link={FileImportCertificate}
            download
            color={azulSebrae36}
          >
            Baixe aqui planilha modelo de dados para importação de certificados
          </BaSeParagraph>
        </WrapperDownloadFile>
      </div>
      <BaSeFilePicker
        acceptsFilesPattern="*"
        onChange={(files) => {
          setSizeFiles(files.length);
          setFiles(files);
        }}
        validateFiles={(files) => {
          const csv = 'text/csv';
          const xls = 'application/vnd.ms-excel';
          const xlsx =
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

          const listValidFiles = files.filter(
            (ele) => ele.type === xlsx || ele.type === xls || ele.type === csv,
          );

          const listInvalidFiles = files.filter(
            (ele) => ele.type !== xlsx && ele.type !== xls && ele.type !== csv,
          );

          const errors = listInvalidFiles.map((e, index) => (
            <span style={{ display: 'grid' }} key={index}>
              {`-${e.name}`}
            </span>
          ));

          if (!!listInvalidFiles.length) {
            showNotification({
              message: 'Tipo de arquivo não permitido!',
              supportMessage: errors,
              color: 'destructive',
              secondsToClose: 15,
            });
          }

          return listValidFiles;
        }}
        onError={({ error }) => console.log('erro', error)}
        pickMultipleFiles
        renderStyle="box"
        dragInfoText={
          <>
            <BaSeParagraph color={cinzaSebrae45}>
              ou arraste aqui para adicionar.
            </BaSeParagraph>
            <BaSeParagraph color={cinzaSebrae45}>
              Formato: CSV, XLSX ou XLS
            </BaSeParagraph>
          </>
        }
      />
      <div style={{ margin: '20px 0' }}>
        <BaSeButton
          isDisabled={sizeFiles < 1}
          value="Executar"
          type="primary"
          color={azulSebrae36}
          onClick={() => {
            sendFiles();
            setIsImportFiles(false);
            setIsReport(true);
          }}
        />
      </div>
    </>
  );
};
